import { LayananTestimonialCarousel } from '@/components/molecules/carousel/layanan-testimonial-carousel'
import Container from '@/components/templates/container/container'

interface Props {
  data: Testimonial
  title?: string
  testimonialVideo?: boolean
  language?: 'id' | 'en'
}

export const LayananTestimonial = ({ data, title, testimonialVideo = false, language }: Props) => {
  return (
    <section className="space-y-10 py-9 lg:py-16">
      <Container>
        <h2 className="text-2xl font-bold text-center lg:text-4xl text-primary-blue">
          {title ?? 'Kata Mereka tentang Easybiz'}
        </h2>
      </Container>
      {testimonialVideo && (
        <div className="relative">
          <iframe
            src="https://www.youtube.com/embed/wwv-C8zSFXw?si=VcAlFZRGnkEuI0CK"
            title="YouTube video player"
            className="w-full h-[200px] sm:h-[60vh] lg:h-[80vh]"
          />
        </div>
      )}

      <Container className="px-1">
        <LayananTestimonialCarousel data={data} language={language} />
      </Container>
    </section>
  )
}
